import { GlobalStore } from '@/store';
import { useQuasar } from 'quasar';

////////////////----공통코드_객체----////////////////
const comm = {
	////////-----프린트 기능-----////////
	getPrint: () => {
		if (typeof window.PanApp?.print === 'function') {
			window.PanApp.print();
		}
	},
	////////-----학교명_학년(비회원_포함)-----////////
	getStrSchoolAndGrade: () => {
		// console.log('getStrSchoolAndGrade 진입');
		const gStore = GlobalStore();
		const grade = gStore.is_member_eval
			? gStore.userInfo.grade
			: gStore.evalData.real_grade;
		// console.log('grade : ', grade);
		return cccSchoolName(grade) + ' ' + cccGrade(grade);
	},

	getDiagnosticSchoolAndGrade: () => {
		const gStore = GlobalStore();
		const grade = gStore.evalData.real_grade;
		// console.log('grade : ', grade);
		return cccSchoolName(grade) + ' ' + cccGrade(grade);
	},

	////////-----이름(비회원은_닉네임)-----////////
	getStrName: () => {
		const gStore = GlobalStore();
		return gStore.is_member_eval
			? gStore.userInfo.studentName
			: gStore.evalData.nick;
	},
	getExamGrade: grade => {
		switch (grade) {
			case 'P1':
			case 'P2':
			case 'P3':
			case 'P4':
			case 'P5':
			case 'P6':
			case 'M1':
				return 'M1';
			case 'M2':
				return 'M2';
			case 'M3':
			case 'H1':
			case 'H2':
			case 'H3':
				return 'M3';
			default:
				return 'M1';
		}
	},
	getFirstPointGrade: grade => {
		switch (grade) {
			case 'P1':
			case 'P2':
			case 'P3':
			case 'P4':
			case 'P5':
			case 'P6':
			case 'M1':
				return 1300;
			case 'M2':
				return 1400;
			case 'M3':
			case 'H1':
			case 'H2':
			case 'H3':
				return 1500;
			default:
				return 1300;
		}
	},
	getBabyAdult: grade => {
		if (!grade) return false;

		if (grade.includes('K')) {
			return String(parseInt(grade.replace(/[^0-9]/g, '')) + 1) + '학년';
		} else if (grade.includes('A')) {
			return ' ';
		} else {
			return false;
		}
	},
	getHakNyoun: grade => {
		switch (grade) {
			case 'P1':
			case 'M1':
			case 'H1':
				return '1학년';
			case 'P2':
			case 'M2':
			case 'H2':
				return '2학년';
			case 'P3':
			case 'M3':
			case 'H3':
				return '3학년';
			case 'P4':
				return '4학년';
			case 'P5':
				return '5학년';
			case 'P6':
				return '6학년';
			default:
				return comm.getBabyAdult(grade) || '1학년';
		}
	},
	getNoOfStudyType: (isTop, text) => {
		// 맞춤 - 맞춤학습
		// 수능 - 수능모의평가
		// 추천학습(수동) - 추천학습
		// 추천학습(자동) - 추천학습
		// 추천학습(진단) - 진단추천
		// 리셋 - 리셋
		// 추천학습  리셋 - 추천학습리셋
		// 수능모의평가 리셋 - 수능모의평가 리셋
		//추천학습(진단)
		switch (text) {
			case '맞춤학습':
				return isTop ? 100 : 200; // 맞춤학습은 위 아래 색깔이 다르다.
			case '수능':
				return 300;
			case '추천학습(수동)':
				return 400;
			case '추천학습(자동)':
				return 500;
			case '추천학습(진단)':
				return 600;
			case '수능모의평가 리셋':
				return 700;
			case '추천학습 리셋':
				return 800;
			case '리셋':
			case '맞춤학습 리셋':
				return 900;
			default:
				return 0;
		}
	},
	getClassOfStudyType: type => {
		switch (type) {
			case 100:
			case 200:
				return ['chip__box', 'samll', 'green'];
			case 300:
			case 400:
			case 500:
			case 600:
				return ['chip__box', 'samll', 'blue'];
			case 700:
			case 800:
				return ['chip__box', 'samll', 'purple'];
			case 900:
				return ['chip__box', 'samll', 'red'];
			default:
				return ['chip__box', 'samll', 'blue'];
		}
	},

	getTypeNameOfStudyType: type => {
		switch (type) {
			case 100:
			case 200:
				return '맞춤학습';
			case 300:
				return '수능모의평가';
			case 400:
			case 500:
				return '추천학습';
			case 600:
				return '진단추천';
			case 700:
				return '수능모의평가 리셋';
			case 800:
				return '추천리셋';
			case 900:
				return '맞춤리셋';
			default:
				return '맞춤학습';
		}
	},
	getImgPath: sentence => {
		if (sentence.includes('생성')) return 100;
		if (sentence.includes('리셋')) return 200;
		if (sentence.includes('수정')) return 300;
		return 100;
	},
	getNoOfInformStudyType: text => {
		// console.log('--text-computed - ', text);
		if (text.includes('추천학습')) return 100;
		// if (text.includes('진도리셋')) return text.includes('수능모의평가') ? 200 : 300;
		if (text.includes('진도리셋')) return 200;
		if (text.includes('리셋')) return 200;
		if (text.includes('진도수정')) return 400;
	},
	getStrOfInformStudyType: text => {
		// console.log('--text-computed - ', text);
		if (text.includes('추천학습')) return '추천학습';
		// if (text.includes('진도리셋')) return text.includes('수능모의평가') ? 200 : 300;
		if (text.includes('진도리셋')) return '진도리셋';
		if (text.includes('리셋')) return '진도리셋';
		if (text.includes('진도수정')) return '진도수정';
	},

	////////-----현재디바이스_타입_대입하기-----////////
	setDeviceType: () => {
		const gStore = GlobalStore();
		const $q = useQuasar();
		gStore.setPlatform('DESKTOP');
		if ($q.platform.is.android) gStore.setPlatform('ANDROID');
		if ($q.platform.is.ios) gStore.setPlatform('IOS');
		// console.log('-Comm-setDeviceType -gStore.platform-', gStore.platform);
	},
};

////////////////----학년----////////////////
function cccGrade(grade) {
	switch (grade) {
		case 'P1':
		case 'M1':
		case 'H1':
			return '1학년';
		case 'P2':
		case 'M2':
		case 'H2':
			return '2학년';
		case 'P3':
		case 'M3':
		case 'H3':
			return '3학년';
		case 'P4':
			return '4학년';
		case 'P5':
			return '5학년';
		case 'P6':
			return '6학년';
		default:
			return comm.getBabyAdult(grade) || '1학년';
	}
}
////////////////----학교명 (회원, 비회원)----////////////////
function cccSchoolName(grade) {
	if (!grade) return '';

	const gStore = GlobalStore();
	// 재시험에서 선택한 grade를 사용하도록 수정
	// if (gStore.is_member_eval) return gStore.userInfo.schoolName;
	return grade.includes('H')
		? '고등학교'
		: grade.includes('M')
		? '중학교'
		: grade.includes('K')
		? '유치원'
		: grade.includes('A')
		? '성인'
		: grade.includes('P')
		? '초등학교'
		: '';
}

export default comm;
